import { useRef, useEffect } from "react"

const useMounted = (onMount = () => {}) => {
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
    onMount()

    return () => {
      mounted.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return mounted
}

export default useMounted
